import { useContext, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ActionType, APPROUTES } from '../../../assets/constants/constants';
import { AppContext } from '../../../context/AppProvider';
import { setLocalStorageData } from '../../../services/user';

const LearnerRedirection = () => {
 
  const navigate = useNavigate(); 
  const params = new URLSearchParams(window.location.search);
  const token = params.get("awsToken");
  const [aswToken,setAswToken] = useState('');
  const { dispatch} = useContext(AppContext);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (token) {
      localStorage.setItem("token", token);
      setAswToken(token);
    } 
  }, [token]);

  useEffect(() => {
     
    const getlocalStorageData = async () => {
      dispatch({ type: ActionType.LOTTIE_ANIMATION, payload: true });

      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      const apiResponse = await setLocalStorageData()
      const details: any = apiResponse?.data[0]?.cognitoTokenDetails;

      if(details) {
        for (const [key, value] of Object.entries(details)) {
          localStorage.setItem(key, String(value));
        }
        dispatch({ type: ActionType.IS_AUTH, payload: true });
      }
      
      timeoutRef.current =  setTimeout(()=>{
        dispatch({ type: ActionType.LOTTIE_ANIMATION, payload: false });
        navigate(APPROUTES.home);
      },2000);

    }

    if(aswToken)
      getlocalStorageData()

  }, [aswToken]);

  useEffect(() => {
      return () => {
        // Cleanup timeout on unmount
        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current);
        }
      };
  }, []);
  
  return (
    <>
      {/* <Learner redrection /> */}
    </>
  );
};

export default LearnerRedirection;
